<div class="modal-header">
    <div class="title">
      <h2 class="modal-title-prefix"><span translate="KURSDOKUMENTSTAVKA.SINGULAR"></span></h2>
      <h1 class="modal-title">
        <span>Stavka</span>
      </h1>
    </div>
    <span class="close" (click)="Close()"><span class="fa fa-fw fa-times"></span></span>
  </div>
  <div class="modal-body">
    <yt-kurs-dokument-stavka-update #baseUpdate></yt-kurs-dokument-stavka-update>
  </div>
  <div class="modal-footer">
    <button type="submit" class="btn btn-primary" (click)="Save()"><span>Sačuvaj</span></button>
    <button type="button" class="btn btn-secondary" (click)="Close()"><span>Zatvori</span></button>
  </div>